import { IStoreState } from "App/types";
import { get, has, mapValues, reduce } from "lodash-es";

import { API_ENDPOINTS } from "shared/constants";
import { IJSONAPIItem } from "shared/types";
import { IDataKeys, IDataState } from "shared/types";

// Helper method to update venue in state
export const getMergedBandState = (
  state: IDataState,
  band: { [key: string]: IJSONAPIItem },
  bandId: string
) => {
  const bandSettings = {
    [IDataKeys.eventTypes]: null,
    [IDataKeys.eventInfoBlockTypes]: null,
    [IDataKeys.eventTicketAndPassTypes]: null,
    [IDataKeys.memberCategories]: null,
  };

  // transform data to redux state
  const bandSettingsState = mapValues(bandSettings, (_val, key) =>
    get(band, [API_ENDPOINTS.BAND(bandId), "attributes", key])?.map((val: any) => ({
      ...val.data.attributes,
      id: val.data.id,
    }))
  );

  return {
    [IDataKeys.band]: {
      ...state.data.band,
      ...band,
    },
    ...bandSettingsState,
  };
};

export const getCalendarCacheKey = (band?: string, start?: string, stop?: string) =>
  `${band || ""}${start || ""}${stop || ""}`;

export const getSubscriptionsAction = (props: { [key: string]: string | undefined | number }) => {
  const query = reduce(
    props,
    (query, value, key) => {
      if (value) {
        return `${query}${query.length ? "&" : ""}${key}=${value}`;
      }
      return query;
    },
    ""
  );
  const action = `${API_ENDPOINTS.SUBSCRIPTIONS}?${query}`;
  return action;
};

export const isPageFetchedInState = (state: IStoreState, paginationKey: string, page: number) => {
  const pageFetched = has(state, ["data", "pagination", paginationKey, "pages", page]);

  return pageFetched;
};
